import BaseService from '../BaseService';
import { PnetService, PnetServiceRequestType } from '@previnet/service';
import config from "@/services/config";
import categories, { file_formats } from "@/services/categories";

const baseUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/` + config.serviceContext;
// edwin
const initProductUrl = baseUrl + `/api/edwin/init-product`;
const getProductUrl = baseUrl + `/api/edwin/get-product`;
const getProductsListUrl = baseUrl + `/api/edwin/list-products`;
const getProductsListVitaInvestimentoUrl = baseUrl + `/api/edwin/list-products-vita-investimento`;
const getProductsListVitaProtezioneUrl = baseUrl + `/api/edwin/list-products-vita-protezione`;
const getProductsListDanniAutoUrl = baseUrl + `/api/edwin/list-products-danni-auto`;
const getProductsListDanniNonAutoUrl = baseUrl + `/api/edwin/list-products-danni-non-auto`;
const getProductsListCPIPPIUrl = baseUrl + `/api/edwin/list-products-cpi-ppi`;
const getProductsListGenericUrl = baseUrl + `/api/edwin/list-products/`;
const addProductPropertyUrl = baseUrl + `/api/edwin/add-product-property`;
const addProductPropertyListUrl = baseUrl + `/api/edwin/add-product-property-list`;
const duplicateProductUrl = baseUrl + `/api/edwin/duplicate-product`;
const deleteProductsListUrl = baseUrl + `/api/edwin/delete-products-list`;
const exportCSVUrl = baseUrl + `/api/edwin/export-products`;
const exportXlsxUrl = baseUrl + `/api/edwin/export-products-excel`;
const exportPptxUrl = baseUrl + `/api/edwin/export-products-pptx`;
const getUserUrl = baseUrl + `/api/edwin/user`;
const getPasswordHintsUrl = baseUrl + `/api/edwin/password-hints`;
const changePasswordUrl = baseUrl + `/api/edwin/change-password`;
const changePasswordForgottenUrl = baseUrl + `/api/edwin/change-password-forgotten`;
const getPropertyValuesUrl = baseUrl + `/api/edwin/property-values`;
const updateProductUrl = baseUrl + `/api/edwin/update-product`;
const massiveUrl = baseUrl + `/api/edwin/massive`;
const massiveConfirmUrl = baseUrl + `/api/edwin/massive/confirm`;
const massiveDeleteUrl = baseUrl + `/api/edwin/massive/delete`;
const massiveGsUrl = baseUrl + `/api/edwin/massive-gs`;
const massiveGsConfirmUrl = baseUrl + `/api/edwin/massive-gs/confirm`;
const massiveGsDeleteUrl = baseUrl + `/api/edwin/massive-gs/delete`;
const saveSearchFilterUrl = baseUrl + `/api/edwin/save-search-filter`;
const getSearchFiltersListUrl = baseUrl + `/api/edwin/list-search-filters`;
const updaterExportUrl = baseUrl + `/api/updater/export`;
const updaterUploadUrl = baseUrl + `/api/updater/upload`;
// edwindwh
const getDataForChartUrl = baseUrl + `/api/edwindwh/get-data-for-chart`;
const getStatisticsForChartUrl = baseUrl + `/api/edwindwh/get-statistics-for-chart`;
const exportChartDataWithFormatUrl = baseUrl + `/api/edwindwh/export-chart-data`;

const headers = new Headers();

export default class RequestService extends BaseService {

  public initProduct(): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      initProductUrl,
      {
        method: 'GET',
        headers,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public initProductWithCategory(category: string): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      initProductUrl + "/" + category,
      {
        method: 'GET',
        headers,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public initProductWithCustomCategory(category: string, customCategory: string): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      initProductUrl + "/" + category + "/" + customCategory,
      {
        method: 'GET',
        headers,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public getProduct(param: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      getProductUrl + "/" + param ,
      {
        method: 'GET',
        headers,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public getProducts(param: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      getProductsListUrl,
      {
        method: 'GET',
        headers,
      },
      {
        'productId': param,
      }
    );

    return serviceCallReturnValue;
  }

  public getProductsList(params: any, codProductCategory: string): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      this.getProductsListUrlByProduct(codProductCategory),
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public addProductProperty(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      addProductPropertyUrl + "/" + params.productId,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params.property,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public addProductPropertyList(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      addProductPropertyListUrl + "/" + params.productId,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params.propertyList,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public duplicateProduct(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      duplicateProductUrl + "/" + params.productId,
      {
        method: 'GET',
        headers,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public deleteProductsList(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      deleteProductsListUrl,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public extractCSV(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      exportCSVUrl,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    )
      .then(this.handleJSONResponse);

    return serviceCallReturnValue;
  }

  public extractXlsx(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      exportXlsxUrl,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public extractPptx(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      exportPptxUrl,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public getUser(): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      getUserUrl,
      {
        method: 'GET',
        headers,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public getPasswordHints(): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      getPasswordHintsUrl,
      {
        method: 'GET',
        headers,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public changePassword(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      changePasswordUrl,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public changePasswordForgotten(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      changePasswordForgottenUrl,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public getPropertyValues(codProductCategory: string): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      getPropertyValuesUrl + "/" + codProductCategory,
      {
        method: 'GET',
        headers,
        type: PnetServiceRequestType.json,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public getPropertyValuesCustom(codProductCategory: string, customCategory: string): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      getPropertyValuesUrl + "/" + codProductCategory + "/" + customCategory,
      {
        method: 'GET',
        headers,
        type: PnetServiceRequestType.json,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public getDataForChart(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      getDataForChartUrl,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public getStatisticsForChart(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      getStatisticsForChartUrl,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public extractChartData(params: any, fileFormat: string): Promise<Response> {
    const vm = this as any;

    let serviceCallReturnValue = undefined;
    if (fileFormat == file_formats.CSV) {
      serviceCallReturnValue = this.extractChartDataCsv(params, fileFormat);
    } else {
      serviceCallReturnValue = this.extractChartDataBinary(params, fileFormat);
    }

    return serviceCallReturnValue;
  }

  public updateProduct(params: any): Promise<Response> {
    const vm = this as any;
    const serviceCallReturnValue = this.fetch(
      updateProductUrl,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    )

    return serviceCallReturnValue;
  }

  public uploadMassive(category: any, file: any): Promise<Response> {
    const vm = this as any;
    const serviceCallReturnValue = this.fetch(
      massiveUrl + "/" + category,
      {
        method: 'POST',
        type: PnetServiceRequestType.formdata,
        body: {
          file
        }
      },
      {
      }
    )

    return serviceCallReturnValue;
  }

  public confirmMassive(massiveId: string): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      massiveConfirmUrl + "/" + massiveId,
      {
        method: 'GET',
        headers,
        type: PnetServiceRequestType.json,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public deleteMassive(massiveId: string): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      massiveDeleteUrl + "/" + massiveId,
      {
        method: 'GET',
        headers,
        type: PnetServiceRequestType.json,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public uploadMassiveGs(file: any): Promise<Response> {
    const vm = this as any;
    const serviceCallReturnValue = this.fetch(
      massiveGsUrl,
      {
        method: 'POST',
        type: PnetServiceRequestType.formdata,
        body: {
          file
        }
      },
      {
      }
    )

    return serviceCallReturnValue;
  }

  public confirmMassiveGs(massiveGsId: string): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      massiveGsConfirmUrl + "/" + massiveGsId,
      {
        method: 'GET',
        headers,
        type: PnetServiceRequestType.json,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public deleteMassiveGs(massiveGsId: string): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      massiveGsDeleteUrl + "/" + massiveGsId,
      {
        method: 'GET',
        headers,
        type: PnetServiceRequestType.json,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public saveSearchFilter(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      saveSearchFilterUrl,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public getSearchFiltersList(codProductCategory: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      getSearchFiltersListUrl + "/" + codProductCategory,
      {
        method: 'GET',
        headers,
        type: PnetServiceRequestType.json,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public updaterExport(category: string): Promise<Response> {
    const serviceCallReturnValue = this.fetch(`${updaterExportUrl}/${category}`, {}, {});

    return serviceCallReturnValue;
  }

  public updaterUpload(category: any, file: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      `${updaterUploadUrl}/${category}`,
      {
        method: 'POST',
        type: PnetServiceRequestType.formdata,
        body: {
          file
        }
      },
      {}
    );

    return serviceCallReturnValue;
  }

  private extractChartDataCsv(params: any, fileFormat: string): Promise<Response> {
    const vm = this as any;
    const serviceCallReturnValue = this.fetch(
      exportChartDataWithFormatUrl + "/" + fileFormat,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    )
      .then(this.handleJSONResponse);

    return serviceCallReturnValue;
  }

  private extractChartDataBinary(params: any, fileFormat: string): Promise<Response> {
    const vm = this as any;
    const serviceCallReturnValue = this.fetch(
      exportChartDataWithFormatUrl + "/" + fileFormat,
      {
        method: 'POST',
        headers,
        type: PnetServiceRequestType.json,
        body: params,
      },
      {
      }
    )

    return serviceCallReturnValue;
  }

  private getProductsListUrlByProduct(codProductCategory: string): any {
    let url = null; 
    
    switch (codProductCategory) {
      case categories.CARDIF:
        url = getProductsListUrl;
        break;
      case categories.VITA_INVESTIMENTO:
        url = getProductsListVitaInvestimentoUrl;
        break;
      case categories.VITA_PROTEZIONE:
        url = getProductsListVitaProtezioneUrl;
        break;
      case categories.DANNI_AUTO:
        url = getProductsListDanniAutoUrl;
        break;
      case categories.DANNI_NON_AUTO:
        url = getProductsListDanniNonAutoUrl;
        break;
      case categories.CPI_PPI:
        url = getProductsListCPIPPIUrl;
        break;
      default:
        //console.log("No such codCategoryProduct!");
        url = getProductsListGenericUrl + codProductCategory;
        break;
    }

    return url;
  }
}
